import { Enum } from '#pagebuilder/lib/enums/Enum.js';

export const ModuleTypeEnum = Enum({
    HOMEPAGE: 'homepage',
    ASSISTANT: 'assistant',
    CONTEXT: 'context',
    REPORTS: 'reports',
    ANALYTICS: 'analytics',
    KNOWLEDGE_CENTER: 'knowledge-center',
    FORUM: 'forum',
    SETTINGS: 'settings',
    PROFILE: 'profile',
    FILES: 'files',
    PLACEHOLDER: 'placeholder',
});
